module.exports = __webpack_public_path__ + "img/770.5a1ffa81.gif";